const BASE_URL = "https://crm.hubsyntax.com";

export const api = {
  auth: {
    me: {
      path: `${BASE_URL}/api/user`,
      responses: {
        200: { parse: (data) => data },
      },
    },
    login: {
      path: `${BASE_URL}/api/login`,
      method: "POST",
      responses: {
        200: { parse: (data) => data },
      },
    },
    logout: {
      path: `${BASE_URL}/api/logout`,
      method: "POST",
    },
    forgotPassword: {
      path: `${BASE_URL}/api/forgot-password`,
      method: "POST",
    },
    forceLogout: {
      path: `${BASE_URL}/api/force-logout`,
      method: "POST",
    },
    heartbeat: {
      path: `${BASE_URL}/api/heartbeat`,
      method: "POST",
    },
    resetPassword: {
      path: (token) => `${BASE_URL}/api/reset-password/${token}`,
      method: "POST",
    },
    checkSession: {
      path: (userId) => `${BASE_URL}/api/check-session/${userId}`,
      method: "GET",
      responses: {
        200: { parse: (data) => data },
      },
    },
    userDetails: {
      path: `${BASE_URL}/api/user-details`,
      responses: {
        200: { parse: (data) => data },
      },
    },
    employees: {
      path: `${BASE_URL}/api/employees`,
    },
    filterEmployee: {
      path: `${BASE_URL}/api/filtered-employees`,
    },
    totalStaff: {
      path: `${BASE_URL}/api/total-staff`,
    },
    projects: {
      create: {
        path: `${BASE_URL}/api/projects`,
        method: "POST",
      },
      update: {
        path: (id) => `${BASE_URL}/api/projects/${id}`,
        method: "PUT",
      },
      delete: {
        path: (id) => `${BASE_URL}/api/projects/${id}`,
        method: "DELETE",
      },
      renameStatus: {
        path: (id) => `${BASE_URL}/api/projects/${id}/rename-status`,
        method: "PUT",
      },
      dragDrop: {
        path: (id) => `${BASE_URL}/api/projects/${id}/task-order`,
        method: "PUT",
      },
      addStatus: {
        path: `${BASE_URL}/api/project/add-status`,
        method: "POST",
      },
      deleteStatus: {
        path: `${BASE_URL}/api/project/delete-status`,
        method: "DELETE",
      },
      projectName: {
        path: (id) => `${BASE_URL}/api/projectName/${id}`,
        method: "PUT",
      },
      addSubProject: {
        path: (id) => `${BASE_URL}/api/projects/sub/${id}`,
        method: "PUT",
      },
      updateSubProject: {
        path: (projectId, subId) =>
          `${BASE_URL}/api/projects/sub/${projectId}/${subId}`,
        method: "PUT",
      },
      deleteSubProject: {
        path: (projectId, subId) =>
          `${BASE_URL}/api/projects/sub/${projectId}/${subId}`,
        method: "DELETE",
      },
      comments: {
        add: {
          path: (projectId, taskId) =>
            `${BASE_URL}/api/auth/projects/${projectId}/tasks/${taskId}/comments`,
          method: "PUT",
        },
      },
      get: {
        path: (projectId, taskId, subProjectId) =>
          subProjectId
            ? `${BASE_URL}/api/auth/projects/${projectId}/tasks/${taskId}/comments?subProjectId=${subProjectId}`
            : `${BASE_URL}/api/auth/projects/${projectId}/tasks/${taskId}/comments`,
        method: "GET",
      },
      order: {
        path: `${BASE_URL}/api/projects/order`,
        method: "PUT",
        responses: { 200: { parse: (data) => data } },
      },
      subOrder: {
        path: `${BASE_URL}/api/subProjects/order`,
        method: "PUT",
        responses: { 200: { parse: (data) => data } },
      },
      loginDetials: {
        path: (projectId) => `${BASE_URL}/api/${projectId}/login-details`,
        method: "PUT",
        responses: { 200: { parse: (data) => data } },
      },
    },
    getprojects: {
      path: `${BASE_URL}/api/get-projects`,
      responses: {
        200: { parse: (data) => data },
      },
    },
    deletePayroll: {
      path: (employeeId, payrollId) =>
        `${BASE_URL}/api/${employeeId}/payroll/${payrollId}`,
      method: "DELETE",
    },
    holiday: {
      create: { path: `${BASE_URL}/api/holiday`, method: "POST" },
      list: { path: `${BASE_URL}/api/get/holiday`, method: "GET" },
      update: (id) => ({
        path: `${BASE_URL}/api/holiday/${id}`,
        method: "PUT",
      }),
      delete: (id) => ({
        path: `${BASE_URL}/api/holiday/${id}`,
        method: "DELETE",
      }),
    },
    contracts: {
      create: {
        path: `${BASE_URL}/api/contracts`,
        method: "POST",
      },
      list: { path: `${BASE_URL}/api/contracts`, method: "GET" },
      update: {
        path: (id) => `${BASE_URL}/api/contracts/${id}`,
        method: "PUT",
      },
      delete: {
        path: (id) => `${BASE_URL}/api/contracts/${id}`,
        method: "DELETE",
      },
    },
    upload: {
      path: `${BASE_URL}/api/upload`,
      method: "POST",
    },
    permissions: {
      create: {
        path: `${BASE_URL}/api/permission`,
        method: "POST",
      },
      getByAdmin: {
        path: `${BASE_URL}/api/permission`,
        method: "GET",
      },
      update: {
        path: (id) => `${BASE_URL}/api/permission/${id}`,
        method: "PUT",
      },
    },
    category: {
      create: {
        path: `${BASE_URL}/api/category`,
        method: "POST",
      },
      getAll: {
        path: `${BASE_URL}/api/category`,
        method: "GET",
      },
      reorder: {
        path: `${BASE_URL}/api/category/reorder`,
        method: "POST",
      },
      delete: {
        path: (id) => `${BASE_URL}/api/category/${id}`,
        method: "DELETE",
      },
      rename: {
        path: (id) => `${BASE_URL}/api/category/${id}`,
        method: "PUT",
      },
      importCSV: {
        path: (id) => `${BASE_URL}/api/category/${id}/import-csv`,
        method: "POST",
      },
      update: {
        path: `${BASE_URL}/api/category/item/update`,
        method: "PATCH",
      },
      addItem: {
        path: (id) => `${BASE_URL}/api/category/${id}/item`,
        method: "POST",
      },
    },
    notifications: {
      getAll: {
        path: (userId) => `${BASE_URL}/api/notifications/${userId}`,
        method: "GET",
      },
      getUnread: {
        path: (userId) => `${BASE_URL}/api/notifications/${userId}/unread`,
        method: "GET",
      },
      markRead: {
        path: (notificationId, userId) =>
          `${BASE_URL}/api/notifications/${userId}/${notificationId}/mark-read`,
        method: "PATCH",
      },
    },
    createUser: {
      path: `${BASE_URL}/api/create`,
      method: "POST",
    },
    setPassword: {
      path: `${BASE_URL}/api/set-password`,
      method: "POST",
    },
    myTeam: {
      path: `${BASE_URL}/api/myTeams`,
      method: "GET",
    },
    deleteUser: {
      path: (id) => `${BASE_URL}/api/delete/${id}`,
      method: "DELETE",
    },
    createDepartment: {
      path: `${BASE_URL}/api/create-department`,
      method: "POST",
    },
    getDepartments: {
      path: `${BASE_URL}/api/departments`,
      method: "GET",
    },
    deleteDepartment: {
      path: (id) => `${BASE_URL}/api/delete-department/${id}`,
      method: "DELETE",
    },
    updateUser: {
      path: (employeeId) => `${BASE_URL}/api/update/${employeeId}`,
      method: "PUT",
    },
    updateUser: {
      path: (employeeId) => `${BASE_URL}/api/update/${employeeId}`,
      method: "PUT",
    },
    updatepayroll: {
      path: (employeeId) => `${BASE_URL}/api/update/${employeeId}/payroll`,
      method: "PUT",
    },
    leave: {
      create: {
        path: `${BASE_URL}/api/leave`,
        method: "POST",
      },

      get: {
        path: (query = {}) => {
          const queryString = new URLSearchParams(query).toString();
          return `${BASE_URL}/api/leave${queryString ? `?${queryString}` : ""}`;
        },
        method: "GET",
        responses: {
          200: { parse: (data) => data },
        },
      },
      update: {
        path: ({ userId, leaveId }) =>
          `${BASE_URL}/api/leave/${userId}/${leaveId}`,
        method: "PUT",
        responses: {
          200: { parse: (data) => data },
        },
      },
    },
    expenses: {
      add: {
        path: `${BASE_URL}/api/expenses`,
        method: "POST",
      },
      getAll: {
        path: `${BASE_URL}/api/expenses`,
        method: "GET",
        responses: {
          200: { parse: (data) => data },
        },
      },
      update: {
        path: (expenseId) => `${BASE_URL}/api/expenses/${expenseId}`,
        method: "PUT",
      },
      delete: {
        path: (expenseId) => `${BASE_URL}/api/expenses/${expenseId}`,
        method: "DELETE",
      },
    },
    hiring: {
      create: {
        path: `${BASE_URL}/api/hiring`,
        method: "POST",
      },
      getAll: {
        path: `${BASE_URL}/api/hiring`,
        method: "GET",
      },
      update: {
        path: (id) => `${BASE_URL}/api/hiring/${id}`,
        method: "PUT",
      },
      delete: {
        path: (id) => `${BASE_URL}/api/hiring/${id}`,
        method: "DELETE",
      },
    },
    leads: {
      create: {
        path: `${BASE_URL}/api/leads`,
        method: "POST",
      },
      getAll: {
        path: `${BASE_URL}/api/leads`,
        method: "GET",
        responses: {
          200: { parse: (data) => data },
        },
      },
      update: {
        path: (leadId) => `${BASE_URL}/api/leads/${leadId}`,
        method: "PUT",
      },
      addComment: {
        path: `${BASE_URL}/api/add-comment`,
        method: "POST",
      },
      updateComment: {
        path: `${BASE_URL}/api/update-comment`,
        method: "PUT",
      },
      deleteComment: {
        path: `${BASE_URL}/api/delete-comment`,
        method: "DELETE",
      },
      delete: {
        path: (userId, leadId) => `${BASE_URL}/api/leads/${userId}/${leadId}`,
        method: "DELETE",
      },
    },
    letters: {
      create: {
        path: `${BASE_URL}/api/letters`,
        method: "POST",
      },
      getall: {
        path: `${BASE_URL}/api/letters`,
        method: "GET",
        responses: {
          200: { parse: (data) => data },
        },
      },
      update: {
        path: (id) => `${BASE_URL}/api/letters/${id}`,
        method: "PUT",
      },
      delete: {
        path: (id) => `${BASE_URL}/api/letters/${id}`,
        method: "DELETE",
      },
      letterSend: {
        path: `${BASE_URL}/api/letters/send`,
        method: "POST",
      },
    },
    attendencePost: {
      path: `${BASE_URL}/api/update-attendance`,
      method: "POST",
    },
  },
};
